import React from 'react';
import { Timer as TimerIcon } from 'lucide-react';

interface TimerProps {
    seconds: number;
}

export const Timer: React.FC<TimerProps> = ({ seconds }) => {
    const formatTime = (secs: number) => {
        const minutes = Math.floor(secs / 60);
        const remainingSeconds = secs % 60;
        return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
    };

    const isUrgent = seconds < 60; // Red if last minute

    return (
        <div className={`flex items-center gap-2 text-sm font-medium transition-colors duration-300 ${isUrgent ? 'text-error' : 'text-text-secondary'}`}>
            <TimerIcon className="w-4 h-4" />
            <span>El código expira en {formatTime(seconds)}</span>
        </div>
    );
};
